import { createSlice } from "@reduxjs/toolkit";

import { init } from "./thunks/init";
import * as thunks from "./thunks/thunks";
import { extraReducers } from "./thunks/extraReducers";

import { reducers } from "./reducers";

import * as organizationSelectors from "./selectors";

export const organizationSlice = createSlice({
  name: "organization",
  initialState: {
    init: {
      status: "idle",
    },
    batches: {},
    childOrganizations: {},
    classifications: {},
    consoleRoles: {},
    customs: [],
    devices: {},
    facilities: {},
    facilitiesList: [],
    mobileRoles: {},
    organization: {},
    products: {},
    productsList: [],
    usersMap: {},
    zones: {},
  },
  reducers: {
    ...reducers,
  },
  extraReducers: {
    ...extraReducers,
  },
});

// Action creators are generated for each case reducer function
const {
  updateOrganization,
  updateChildOrganizations,
  updateProducts,
  updateBatches,
  updateFacilities,
  addZone,
  removeZone,
  editZone,
  updateFacility,
  updateClassifications,
  updateCustoms,
  updateUsersMap,
} = organizationSlice.actions;

export {
  updateClassifications,
  updateCustoms,
  updateOrganization,
  updateChildOrganizations,
  updateProducts,
  updateBatches,
  updateFacilities,
  updateFacility,
  addZone,
  removeZone,
  updateUsersMap,
  editZone,
  init,
  organizationSelectors,
  thunks,
};

export const organizationErrorSelector = (state) => state.organization.error;

export default organizationSlice.reducer;
